import { useQuery } from '@apollo/client'
import { GET_CAMPAIGNS_WITH_ADSETS } from '@/graphql/ads/ad-campaigns-queries'

export function useAdsetData(campaignId, adSetId) {
    const { data, loading, error } = useQuery(GET_CAMPAIGNS_WITH_ADSETS, {
        variables: { campaignId },
        skip: !campaignId,
    })

    // Find the adset from the campaign data
    const campaigns = data?.AdCampaign?.campaignsWithAdSets || []
    const adSet = findAdSet(campaigns, adSetId)

    return {
        adSet,
        loading,
        error,
    }
}

const findAdSet = (campaigns, id) => {
    let adSet = null

    for (const campaign of campaigns) {
        for (const stageGroup of campaign.adSetsByStage) {
            const foundAdSet = stageGroup.adSets.find((as) => as.db_id === id)
            if (foundAdSet) {
                adSet = foundAdSet
                break
            }
        }

        if (adSet) break
    }

    return adSet
}
